module.exports = __webpack_public_path__ + "img/insecticida.37f574bc.svg";